<template>
  <PageContainer>
    <h1>Users</h1>
    <table>
      <thead>
        <tr>
          <th>User ID</th>
          <th>Name</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="u in users" :key="u">
          <td>{{ u.id }}</td>
          <td>{{ u.name }}</td>
          <td>
            <button @click="manageUser(u.id)">Manage</button>
          </td>
        </tr>
      </tbody>
    </table>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import User from '@/models/user'

export default {
  name: 'AdminUsersPage',
  components: {
    PageContainer,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      users: undefined,
    }
  },
  beforeMount() {
    this.getUsers()
  },
  watch: {
  },
  methods: {
    async getUsers() {
      this.users = await User.getAll()
    },
    async manageUser(id) {
      this.$router.push('/admin/user?u=' + id)
    }
  },
  computed: {
  }
}
</script>